/**
 *    @tableOfContent
 *      1. Dependencies
 *      2. Class
 *      3. Export class
 *
 */

/**
 *     @section 1. Dependencies
 */
// import App from '../App/App-Basics'
import 'bootstrap/js/src/modal'

/**
 *     @section 2. Class
 */

class Modal {
  private modalDialogsEl: NodeListOf<HTMLElement> | null

  constructor() {
    if (this.cacheDom()) {
      this.addAdditionalCssClassWhenOpen()
      this.closeModalIfLinkWasClicked()
    }

    document.addEventListener('page:enter', () => {
      if (this.cacheDom()) {
        this.closeModalIfLinkWasClicked()
      }
    })
  }

  private cacheDom(): boolean {
    const modalDialogsElement: NodeListOf<HTMLInputElement> | null = document.querySelectorAll('.modal')

    if (!modalDialogsElement) {
      return false
    }

    this.modalDialogsEl = modalDialogsElement

    return true
  }

  private addAdditionalCssClassWhenOpen(): void {
    // // App.log('Component: Modal')

    // this.modalDialogsEl?.forEach((modalDialogEl) => {
    //   modalDialogEl.addEventListener('show.bs.modal', () => {
    //     document.body.classList.add(`modal-open--${modalDialogEl.id}`)
    //   })

    //   modalDialogEl.addEventListener('hidden.bs.modal', () => {
    //     document.body.classList.remove(`modal-open--${modalDialogEl.id}`)
    //   })

    //   modalDialogEl.addEventListener('hidePrevented.bs.modal', () => {
    //     const targetEl = modalDialogEl?.querySelector('.modal__content') as HTMLElement
    //     // App.animation(targetEl, 'fx--shake-x')
    //   })
    // })
  }

  private closeModalIfLinkWasClicked(): void {
    // const modalLinksEl = document.querySelectorAll('.modal a[href]:not([target="_blank"])')
    // modalLinksEl?.forEach((linkEl: HTMLLinkElement) => {
    //   linkEl.addEventListener('click', () => {
    //     const closeButtonEl: HTMLButtonElement | null | undefined = linkEl.closest('.modal')?.querySelector('[data-bs-dismiss="modal"]')
    //     closeButtonEl?.click()
    //   })
    // })
  }
}

/**
 *     @section 3. Export class
 */

export default new Modal()

// end of modal.ts file
